import one360 from './one360';
import type { DocumentType } from '../../types/documents';

export const getDocumentTypes = async (phaseId?: string): Promise<DocumentType[]> => {
  const params = phaseId ? { phaseId } : undefined;
  return one360.get<DocumentType[]>('/api/v1/document-types', { params });
};
